import { render, staticRenderFns } from "./icon-link.vue?vue&type=template&id=475f825f&scoped=true"
import script from "./icon-link.vue?vue&type=script&lang=js"
export * from "./icon-link.vue?vue&type=script&lang=js"
import style0 from "./icon-link.vue?vue&type=style&index=0&id=475f825f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475f825f",
  null
  
)

export default component.exports